module.exports = __webpack_public_path__ + "img/mapa_toks.7df3443f.svg";